import Highcharts from 'highcharts';

// Types
import { formatMessage } from '@/utils/i18n';
import { getChartTooltipHeader, getTooltipPointsToDisplay, MAX_ITEMS_IN_CHART_TOOLTIP } from '@/views/components/charts/utils/tooltip';
import { HighchartPoint } from '@/views/components/charts/utils/types/tooltip';

// Utils
import Dictionary from '@/types/dictionary';
import { COMPARISON_ITEM_TYPES } from '@/utils/constants';
import { currencyToText } from '@/utils/currency';

const ICON_NAMES: Dictionary<string> = {
  [COMPARISON_ITEM_TYPES.ALT]: 'icon-ds-product-alternative',
  [COMPARISON_ITEM_TYPES.BENCHMARK]: 'icon-score',
  [COMPARISON_ITEM_TYPES.FUND]: 'icon-icon-circle',
  [COMPARISON_ITEM_TYPES.GROUP]: 'icon-folder',
  [COMPARISON_ITEM_TYPES.PORTFOLIO]: 'icon-icon-portfolio',
  [COMPARISON_ITEM_TYPES.STOCK]: 'icon-icon-diamond',
};

export const getIconName = (type: string) => ICON_NAMES[type];

function getItemReturnsTemplate(point: HighchartPoint) {
  return `<tr class="chart-tooltip-item">
    <td class="chart-tooltip-icon">
      <i class="${getIconName(point.series.userOptions.itemType)} holding-icon" style="color: ${point.series.color};"></i>
    </td>
    <td class="chart-tooltip-item-name pe-4" data-private data-dd-privacy="mask">${point.series.name}</td>
    <td class="chart-tooltip-item-value text-end">${Number(point.y).toFixed(2)} ${currencyToText(point.series.userOptions.currency)}</td>
  </tr>`;
}

export function getGrowthChartTooltipBody(points: HighchartPoint[], maxItems = MAX_ITEMS_IN_CHART_TOOLTIP) {
  const body = `<table>${getTooltipPointsToDisplay(points, maxItems).map(getItemReturnsTemplate).join('')}</table>`;
  const overflowNotice =
    points.length > maxItems ? `<div class="chart-tooltip-overflow-notice">+ ${points.length - maxItems} ${formatMessage('Common.More')}</div>` : '';
  return `<div class="chart-tooltip-body">${body}${overflowNotice}</div>`;
}

export function performanceTooltipFormatter(this: Highcharts.TooltipFormatterContextObject & { points: HighchartPoint[] }) {
  const header = getChartTooltipHeader({ x: this.x as number, timeFormatter: this.points?.[0].series?.chart?.time });
  return header + getGrowthChartTooltipBody(this.points);
}
